import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface NotificationToken {
  apiKey: string;
  subscriberToken: string;
  apiUrl: string;
  wsUrl: string;
}

export class NotificationsApi {
  protected endpoint = '/user/notification-token';

  constructor(private readonly http: HttpClient) {}

  public getToken(): Observable<NotificationToken> {
    return this.http.get<NotificationToken>(this.endpoint);
  }
}
